import './styles.scss';
import mask from 'images/mission-mask.svg';

const MissionAndValuesSection = ({ data }) => {
    const maskStyle = { maskImage: `url(${mask})`, WebkitMaskImage: `url(${mask})` };
    return (
        <div className="mission-values-section">
            <div className="mission-section">
                <div className="mission-section__gradient" />
                <div className="mission-section__mask" style={maskStyle}>
                    <img src={data.background} alt="" />
                </div>
                <div className="mission-section__title">{data.title}</div>
            </div>
            <div className="values-section" style={{ backgroundImage: `url(${data.background})` }}>
                {data.cards.map((card, index) => (
                    <div className="values-card-wrapper" key={index}>
                        <div className="angle-decor" />
                        <div className="values-card">
                            <div className="gradient-number light">
                                <span>{index + 1}</span>
                            </div>
                            {card.title && <div className="values-card__title">{card.title}</div>}
                            {card.text && <div className="values-card__text">{card.text}</div>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MissionAndValuesSection;
